import { render, staticRenderFns } from "./SellerAdm.vue?vue&type=template&id=636eb964&"
import script from "./SellerAdm.vue?vue&type=script&lang=js&"
export * from "./SellerAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports